module.exports = __webpack_public_path__ + "media/besofen_4.9dfea047.mp4";